export default {
  attachmentList: [],
  attachmentInfo: null,
  attachmentUserList: [],
  attachmentForParentList: [],
  attachmentForSubList: [],
  attachmentForRouteList: [],
  attachmentForDropRouteList: [],
  pickupRouteList: [],
  dropRouteList: []
}
